// test162
(162 && 0);
